import clsx from 'clsx'
import { FC } from 'react'

const PdfPreview: FC<{
  url: string
  height: string
  title: string
  className?: string
}> = ({ url, height = '600px', title = 'PDF Preview', className }) => {
  return (
    <div
      className={clsx(
        'w-full border rounded-3xl aspect-[11/8] bg-jaa-shades-bg shado-sm object-cover object-center overflow-hidden',
        className
      )}
    >
      <iframe
        src={url}
        width='100%'
        height={height}
        title={title}
        className='border-none'
      >
        <p>
          Your browser does not support previewing PDF files. You can{' '}
          <a href={url} target='_blank' rel='noopener noreferrer'>
            download the PDF here
          </a>
          .
        </p>
      </iframe>
    </div>
  )
}

export default PdfPreview
